module.exports = __webpack_public_path__ + "static/4-f9902778b9fc88cf6ed5cbf85844e88e.jpg";